import React, {useState, useEffect} from 'react';
import {Main,Axios,Loading,usePaginacion,Paginacion} from '../Helpers/importacionesComunes'
import { Button, Card, Checkbox, Input, Option, Select, Spinner, Typography, Switch } from '@material-tailwind/react';
import DatePicker from "react-datepicker";
import { SeleccionadorX } from './SeleccionadorX';
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import es from 'date-fns/locale/es';

export default function ParametrosReportesTiempo({parametros,handleCheckCriterio,setParametros}){
const [periodosFiscales,setPeriodosFiscales] = useState([]);

registerLocale('es', es)

useEffect(()=>{
    buscarTablasGenerales()
},[])

const buscarTablasGenerales = async ()=>{
        try{
            const vectorResultados = await Promise.all([Axios.get('/api/tablasgenerales/reportes/perfiscales')])
            setPeriodosFiscales(vectorResultados[0].data.reverse())
        }catch(err){
            console.log('Error al buscar los datos generales',err)  
        }
    }

    if(!parametros){
        return null
    }

    return <Card className="w-full px-6 py-3 mb-3 shadow-md">
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                                {/* Primera columna */}
                                <div className={`flex items-center gap-2 w-full egreso-new ${parametros.criterio=="periodo" ? 'mt-4' : ''}`}>
                                    <div className='w-[220px]'>
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Intervalo de Tiempo:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-full">
                                            <select
                                                label="Seleccionar Intervalo"
                                                value={parametros.criterio}
                                                className='select-bg-ui'
                                                onChange={(val) =>  handleCheckCriterio(val)}
                                            >
                                                <option value="periodo">Periodo</option>
                                                <option value="añofiscal">Año fiscal</option>
                                                <option value="mesaño">Mes/año</option>
                                                <option value="año">Año</option>
                                            </select>                                       
                                        </div>   
                                    </div>
                                </div>

                            <div className="flex flex-col w-full">
                                <div className="relative mt-2 w-full">
                                    {parametros.criterio=="añofiscal" && <div className="flex f-row w-full">
                                        <SeleccionadorX newversion={true} id="select-añofiscal" vector={periodosFiscales} valor={parametros.id_año_fiscal} nombre="Todos" onchange={(e)=>setParametros({...parametros,id_año_fiscal:e.target.value})} claves={{id:'id_año_fiscal',nombre:'nombre'}}/>
                                    </div>}     

                                    {parametros.criterio=="mesaño" && <div className="flex f-row w-full">
                                                {<DatePicker selected={parametros.mesAño} 
                                                    onChange={date => setParametros({...parametros,mesAño:date})} 
                                                    locale="es"
                                                    dateFormat="MM/yyyy"
                                                    id="select-mesaño"
                                                    className="select-bg-ui !h-9"
                                                    showMonthYearPicker
                                                    showFullMonthYearPicker
                                                    showFourColumnMonthYearPicker
                                                />}
                                    </div>}

                                    {parametros.criterio=="año" && <div className="flex f-row w-full">
                                                {<DatePicker selected={parametros.año} 
                                                    onChange={date => setParametros({...parametros,año:date})} 
                                                    locale="es"
                                                    id="select-año"
                                                    className="select-bg-ui !h-9"
                                                    showYearPicker
                                                    dateFormat="yyyy"
                                                />}
                                    </div>}

                                    {parametros.criterio=="periodo" && <div className="flex flex-row w-full items-start">
                                        <div className="flex flex-row">
                                            <div className="flex flex-col">
                                            <span className="text-xsmall">Desde</span>
                                            <DatePicker
                                                selected={parametros.fechaDesde}
                                                onChange={(date) => setParametros({ ...parametros, fechaDesde: date })}
                                                locale="es"
                                                dateFormat="MM/yyyy"
                                                id="select-periodo-fdesde"
                                                showMonthYearPicker
                                                className="select-bg-ui !h-9"
                                                showFullMonthYearPicker
                                                showFourColumnMonthYearPicker
                                            />
                                            </div>
                                            <div className="flex flex-col ml-2">
                                            <span className="text-xsmall">Hasta</span>
                                            <DatePicker
                                                selected={parametros.fechaHasta}
                                                onChange={(date) => setParametros({ ...parametros, fechaHasta: date })}
                                                locale="es"
                                                dateFormat="MM/yyyy"
                                                id="select-periodo-fhasta"
                                                className="select-bg-ui !h-9"
                                                showMonthYearPicker
                                                showFullMonthYearPicker
                                                showFourColumnMonthYearPicker
                                            />
                                            </div>
                                        </div>
                                    </div>}

                                    {parametros.criterio=="fecha" && <div className="flex f-row w-full">
                                            <div className="flex f-row egreso-list w-full">
                                                    <DatePicker selected={parametros.fecha} 
                                                        id="select-fecha"
                                                        className="select-bg-ui !h-9 w-full"
                                                        onChange={date => setParametros({...parametros,fecha:date})} 
                                                        locale="es"/>
                                            </div>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </Card>
}


